import React, { createContext, useState, useEffect } from "react";

const ScreenContext = createContext(null);

const ScreenProvider = ({ children }) => {
  
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isDarkMode, setIsDarkMode] = useState(window.matchMedia("(prefers-color-scheme: dark)").matches);

  useEffect(() => {
      const handleResize = () => {
          setIsMobile(window.innerWidth <= 768);
      };

      const darkModeMediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
      const handleDarkModeChange = (e) => setIsDarkMode(e.matches);

      darkModeMediaQuery.addEventListener("change", handleDarkModeChange);

      window.addEventListener("resize", handleResize);
      return () => {
          darkModeMediaQuery.removeEventListener("change", handleDarkModeChange);
          window.removeEventListener("resize", handleResize);
      };
  }, []);

  return (
    <ScreenContext.Provider
      value={{
        isMobile,
        isDarkMode
      }}
    >
      {children}
    </ScreenContext.Provider>
  );
};

export { ScreenContext, ScreenProvider };
